import { BehaviorSubject, Observable } from "rxjs";
import { AccionesItemDTO, ItemPreguntaDTO } from "@DTOS";
import { Nilable } from "@shared/utils";

export class ItemPreguntaModelDTO {
    public changed$: Observable<boolean>;

    private _changed$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _entidad: ItemPreguntaDTO;

    constructor(entidad: ItemPreguntaDTO) {
        this._entidad = entidad;
        this.changed$ = this._changed$;
    }

    public get Id(): number {
        return this._entidad.id;
    }

    public set Id(valor: number) {
        this._entidad.id = valor;
        this._changed$.next(true);
    }

    public get Acciones(): AccionesItemDTO[] {
        return this._entidad.acciones;
    }

    public set Acciones(valor: AccionesItemDTO[]) {
        this._entidad.acciones = valor;
        this._changed$.next(true);
    }

    public get PreguntaId(): number {
        return this._entidad.preguntaId;
    }

    public set PreguntaId(valor: number) {
        this._entidad.preguntaId = valor;
        this._changed$.next(true);
    }

    public get PreguntaSiguiente(): Nilable<number> {
        return this._entidad.preguntaSiguiente;
    }

    public set PreguntaSiguiente(valor: Nilable<number>) {
        this._entidad.preguntaSiguiente = valor;
        this._changed$.next(true);
    }

    public get PadreId(): Nilable<number> {
        return this._entidad.padreId;
    }

    public set PadreId(valor: Nilable<number>) {
        this._entidad.padreId = valor;
        this._changed$.next(true);
    }

    public get HijoId(): Nilable<number> {
        return this._entidad.hijoId;
    }

    public set HijoId(valor: Nilable<number>) {
        this._entidad.hijoId = valor;
        this._changed$.next(true);
    }

    public get EsOpcionKiller(): Nilable<boolean> {
        return this._entidad.esOpcionKiller;
    }

    public set EsOpcionKiller(valor: Nilable<boolean>) {
        this._entidad.esOpcionKiller = valor;
        this._changed$.next(true);
    }

    public get Texto(): string {
        return this._entidad.texto;
    }

    public set Texto(valor: string) {
        this._entidad.texto = valor;
        this._changed$.next(true);
    }

    public get Condiciones() {
        return this._entidad.condiciones;
    }

    public set Condiciones(condiciones: Nilable<string>) {
        this._entidad.condiciones = condiciones;
        this._changed$.next(true);
    }

    public get IdRelativo(): string {
        return this._entidad.idRelativo;
    }

    public set IdRelativo(valor: string) {
        this._entidad.idRelativo = valor;
        this._changed$.next(true);
    }

    public get ClienteId(): Nilable<string> {
        return this._entidad.clienteId;
    }

    public set ClienteId(valor: Nilable<string>) {
        this._entidad.clienteId = valor;
        this._changed$.next(true);
    }

    public get Payload(): any {
        return this._entidad.payload;
    }

    public set Payload(valor: any) {
        this._entidad.payload = valor;
        this._changed$.next(true);
    }

    public get Checkpoint(): boolean {
        return this._entidad.checkpoint;
    }

    public set Checkpoint(valor: boolean) {
        this._entidad.checkpoint = valor;
        this._changed$.next(true);
    }

    public get Alineacion(): Nilable<"T" | "B"> {
        return this._entidad.alineacion;
    }

    public set Alineacion(valor: Nilable<"T" | "B">) {
        this._entidad.alineacion = valor;
        this._changed$.next(true);
    }

    public get Entidad(): ItemPreguntaDTO {
        return this._entidad;
    }

    public set Entidad(entidad: ItemPreguntaDTO) {
        this._entidad = entidad;
        this._changed$.next(true);
    }
}
